import request from '@/plugin/axios'

export function createRole (data) {
  return request({
    url: '/api/admin/role',
    method: 'post',
    data: data
  })
}
export function updateRole (data) {
  return request({
    url: '/api/admin/role/' + data.id,
    method: 'put',
    data: data
  })
}

export function delRole (data) {
  return request({
    url: '/api/admin/deleteRole',
    method: 'post',
    data: data
  })
}
export function setRolePermission (data) {
  return request({
    url: '/api/admin/setRoleAuth',
    method: 'post',
    data: data
  })
}
export function getOrgRoles (data) {
  return request({
    url: '/api/admin/role',
    method: 'get',
    params: data
  })
}
export function getUserRole (data) {
  return request({
    url: '/api/admin/queryRoleByUser',
    method: 'put',
    data: data
  })
}
export function setUserRole (data) {
  return request({
    url: '/api/admin/setUserRole',
    method: 'put',
    data: data
  })
}
